import request from '@/utils/request'

export function getOSSAuthorization(policy) {
  return request({
      url: '/procurement/api/oss/sts?policy=' + policy,
      method: 'get'
  });
}
